import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PrimengTableCols} from '@sharedcommon/interfaces/primeng-table-cols';
import {PrimengTableService} from '@sharedcommon/components/primeng-table/primeng-table.service';
import {CoherenceEquation} from '@admincommon/models/references/coherence-equation.model';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {PrimengCheckColumnModel} from '@sharedcommon/model/primeng-check-column.model';
import {EntityRightDto, VariableValueImportPredModPreviewDto} from '@sharedrest/data.restservice';
import {VariableDto} from '@sharedrest/equation.restservice';
import {TranslateService} from '@ngx-translate/core';
import { RawMaterialOrSampleUtil } from '@sharedcommon/util/rawmaterial-or-sample.util';

@Component({
  selector: 'neq-primeng-table-cell-types',
  templateUrl: './primeng-table-cell-types.component.html',
  styleUrls: ['./primeng-table-cell-types.component.css']
})
export class PrimengTableCellTypesComponent implements OnInit {

  @Input() col: PrimengTableCols;

  @Input() rowData: any;

  /**
   * Emitter called when the user check the checkbox on a c
   */
  @Output() checkCellEmitter = new EventEmitter<PrimengCheckColumnModel>();

  constructor(
    private readonly translateService: TranslateService,
    private readonly domSanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    // Required
  }

  /**
   * Return the right url for the logo picture
   *
   * @param logo name of the logo
   */
  getSanitizeLogo(logo: string): SafeUrl {
    return this.domSanitizer.bypassSecurityTrustUrl(logo);
  }

  /**
   * Return true if a nutrient is locked false otherwise
   */
  isLocked(): boolean {
    return RawMaterialOrSampleUtil.isLocked(this.rowData);
  }

  /**
   * Change the toggle state of the equation formula
   *
   * @param row
   */
  toggleRowExpansion(row: CoherenceEquation) {
    row[this.col.fieldExpand] = !row[this.col.fieldExpand];
  }

  /**
   * Check if the line is the principal matrix of the entity
   *
   * @param row line of the table
   */
  isPrincipalMatrixOfEntity(row: EntityRightDto) {
    return this.col.checkOutsideNgModel.matrix && row && this.col.checkOutsideNgModel.entities.some(e => e.code === row.entity.identifier
      && e.principalMatrix.identifier === this.col.checkOutsideNgModel.matrix.code);
  }

  /**
   * format the list of value in the column
   *
   * @param list string list delimited by ","
   */
  formatList(list: Array<string>): string {
    return list.join('\n');
  }

  /**
   * Show equation or condition label depending of the value conditionVariable
   *
   * @param row Object of the current line
   */
  getVariableType(): string {
    return (this.rowData.conditionVariable)
      ? 'label.admin.variable.type.condition'
      : 'label.admin.variable.type.equation';
  }

  /**
   * Return the check status of the checkbox on import value page
   *
   * @param row linte of the table
   */
  isChecked(row: VariableValueImportPredModPreviewDto): boolean {
    return row && this.col.checkOutsideNgModel.indexOf(row.predictionModel) >= 0;
  }

  /**
   * Emit the event of check or uncheck the all nutrients column
   *
   * @param value
   */
  emitChecked(value: any) {
    this.checkCellEmitter.emit({checkEvent: value, row: this.rowData, field: this.col.field});
  }

  /**
   * Return the right toolitip translated string from variables
   *
   * @param variable variable of the dynamic column
   */
  getVariableTooltip(variable: VariableDto) {
    return PrimengTableService.returnVariableTooltip(variable, this.translateService);
  }

  /**
   * Return the raw data to display of the cell
   */
  returnRawRowDataToDisplay(): any {
    return PrimengTableService.returnRawRowDataToDisplay(this.col, this.rowData);
  }

}
